// config/docTypeConfig.js

export const docTypeConfig = {
  "/client-counter": [
    "Letter of Reliance",
    "Proof of Regulated Status",
    "Proof of Listing on a Recognised Exchange",
    "Official Copy/Dastcha"
  ],
  "/corporate-structure": [
    "Entity Structure Chart",
    // "UBO Proof from company house",
    "Proof of Trustee Regulation",
    "Certified copy of passport/other ID",
    "Proof of address",
    "Certificate of Incorporation or Equivalent Incorporation Document",
    "Last filed accounts",
    "Memorandum & Articles of Association",
    // "Evidence of Companies House registration (screenshot)",
    "Evidence of the company Officers",
    "Evidence of the register of Persons with Significant Control",
    "Partnership Deed",
    "Certificate of Incorporation of a Partnership",
    "Evidence of the list of Partners (PSC register)",
    // "Evidence of listing on a recognised stock exchange",
    "Evidence of regulated status",
    "Evidence of registration with Pensions Regulator",
    "Evidence of registration with HMRC as a recognised pension fund",
    "Certified copy Trust Deed",
    "Certified copy passports (or other appropriate ID) for the Trustees",
    "Certified copy passports (or other appropriate ID) for the Beneficiaries (if defined benefit trust)",
    "Proof of address for the Beneficiaries",
    "Certificate of Incorporation",
    "Certified register of directors",
    "Certified copy passports for the directors",
    "Certified Copy Passport",
    "Certified copy passport (or other appropriate ID) for the Settlor",
    "Certified copy passports for the Protector/Controller",
    "Screenshot of International Working Group of Sovereign Wealth Funds membership",
    "Certified copy of the foundation’s formation documents",
    "Official records confirming its registration (corporate registry extract)",
    "Website printout evidencing the full name of the entity, the nature and status and the name of its home-state authority",
    "Evidence that the Charity is recognised by the home state authority",
    "Evidence that the Church Body or Place of Worship is recognised by the home state authority",
    "Evidence of the Funds regulated status",
    "Evidence of the Fund Manager’s regulated status",
    "Protector/Controller ID document",
    "Screenshot of PSC Register",
    "UBO Screen Shot of PSC Register",
    "Trust company director ID",
    "Trust company director proof of address",
    "UBO Certificate of Incorporation"
  ],
  "/management-structure": [
    "Certified copy of passport/other ID",
    "Proof of address",
    "Certificate of Incorporation or Equivalent Incorporation Document",
    "Last filed accounts",
    "Memorandum & Articles of Association",
    // "Evidence of Companies House registration (screenshot)",
    "Evidence of the company Officers",
    "Evidence of the register of Persons with Significant Control",
    "Partnership Deed",
    "Certificate of Incorporation of a Partnership",
    "Evidence of the list of Partners (PSC register)",
    // "Evidence of listing on a recognised stock exchange",
    "Evidence of regulated status",
    "Evidence of registration with Pensions Regulator",
    "Evidence of registration with HMRC as a recognised pension fund",
    "Certified copy Trust Deed",
    "Certified copy passports (or other appropriate ID) for the Trustees",
    "Certified copy passports (or other appropriate ID) for the Beneficiaries (if defined benefit trust)",
    "Proof of address for the Beneficiaries",
    "Certificate of Incorporation",
    "Certified register of directors",
    "Certified copy passports for the directors",
    "Certified Copy Passport",
    "Certified copy passport (or other appropriate ID) for the Settlor",
    "Certified copy passports for the Protector/Controller",
    "Screenshot of International Working Group of Sovereign Wealth Funds membership",
    "Certified copy of the foundation’s formation documents",
    "Official records confirming its registration (corporate registry extract)",
    "Website printout evidencing the full name of the entity, the nature and status and the name of its home-state authority",
    "Evidence that the Charity is recognised by the home state authority",
    "Evidence that the Church Body or Place of Worship is recognised by the home state authority",
    "Evidence of the Funds regulated status",
    "Evidence of the Fund Manager’s regulated status",
    "Protector/Controller ID document",
    "UBO Screen Shot of PSC Register",
    "Trust company director ID",
    "Trust company director proof of address",
    "UBO Certificate of Incorporation"
  ],
  "/RiskAsses": [
    "Electronic Screening Report(s)",
    "Intermediary - ID Document",
    "Intermediary - Electronic screening"
  ],
  "/Edd": [
    "Official Copy of the Charges Register"
  ],
  "/transaction-detail": [
    "Term sheet (optional)"
  ]
};

// Document types that allow multiple file uploads
export const MULTI_FILE_DOC_TYPES = ["Electronic Screening Report(s)"];
